import { render, staticRenderFns } from "./MatchRuleButton.vue?vue&type=template&id=47cc2d26"
import script from "./MatchRuleButton.vue?vue&type=script&lang=js"
export * from "./MatchRuleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports